function TrasparenzaContent() {
    return (
        <>
            <div className="text space">
                Settemotivi - Legge 4 agosto 2017 n. 124
            </div>
            <div className="text space">
                Settemotivi - ODV non ha ricevuto nell'anno 2025 contributi pubblici superiori a € 10.000/00.
            </div>
            <div className="table-scroll">
                <table>
                    <tbody>
                    <tr>
                        <th>Soggetto erogatore</th>
                        <th>Data ricevimento</th>
                        <th>Importo erogato</th>
                        <th>Riferimento</th>
                    </tr>
                    <tr>
                        <td>COMUNE DI PORDENONE</td>
                        <td>21/01/2025</td>
                        <td>€ 560,00</td>
                        <td>CONTRIBUTO ODRINARIO ASSOCIAZIONI ANNO 2024 ACCONTO</td>
                    </tr>
                    <tr>
                        <td>COMUNE DI PORDENONE</td>
                        <td>28/03/2025</td>
                        <td>€ 560,00</td>
                        <td>CONTRIBUTO ODRINARIO ASSOCIAZIONI ANNO 2024 SALDO </td>
                    </tr>

                    <tr>
                        <td>REGIONE FRIULI VENEZIA GIULIA</td>
                        <td>09/06/2025</td>
                        <td>€ 1920,00</td>
                        <td>ACCONTO PROGETTO ODV – ANNO 2025 / 2026 LEGGE REGIONALE 9 NOVEMBRE 2012, N. 23 (DISCIPLINA ORGANICA SUL VOLONTARIATO E SULLE ASSOCIAZIONI DI PROMOZIONE SOCIALE)</td>
                    </tr>

                    <tr>
                        <td>COMUNE DI PRATA DI PORDENONE</td>
                        <td>18/07/2025</td>
                        <td>€ 50,00</td>
                        <td>
                            CONTRIBUTO ORDINARIO ASSOCIAZIONE SALDO ANNO 2024
                        </td>
                    </tr>



                    <tr>
                        <td>REGIONE FRIULI VENEZIA GIULIA</td>
                        <td>20/08/2025</td>
                        <td>€ 1216,00</td>
                        <td>SALDO PROGETTO ANNO 2024 /2025 LEGGE REGIONALE 9 NOVEMBRE 2012, N. 23 (DISCIPLINA ORGANICA SUL VOLONTARIATO E SULLE ASSOCIAZIONI DI PROMOZIONE SOCIALE)
                        </td>
                    </tr>

                    <tr>
                        <td>REGIONE FRIULI VENEZIA GIULIA</td>
                        <td>27/08/2025</td>
                        <td>€ 200,000</td>
                        <td>CONTRIBUTO ASSICURAZIONI VOLONTARII ANNO 2025
                        </td>
                    </tr>

                    <tr>
                        <td>COMUNE DI PRATA DI PORDENONE</td>
                        <td>24/10/2025</td>
                        <td>€ 150,00</td>
                        <td>
                            CONTRIBUTO ORDINARIO ASSOCIAZIONE ACCONTO ANNO 2025
                        </td>
                    </tr>

                    <tr>
                        <td>COMUNE DI PORDENONE</td>
                        <td>09/12/2025</td>
                        <td>€ 560,00</td>
                        <td>
                            CONTRIBUTO ORDINARIO ASSOCIAZIONI ANNO 2025 ACCONTO
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div style={{ "margin": "1rem" }}>
                pubblicazione dei contributi ricevuti ai sensi della legge 4 agosto 2017 n. 124 art. 1, commi da 125 a 127
            </div>
        </>
    );
}

export default TrasparenzaContent;
